<!-- <div class="form-group">
  <label for="">{{ attribute.key }}</label>
  <div id="froala-editor"
    [froalaEditor]="options"
    [(froalaModel)]="attribute.value"></div>
</div> -->
<div class="form-group">
  <label for="">{{ attribute.key }} </label>
  <span class="error-indication" *ngIf="isRequired()">{{getError()}}</span>
  <quill-editor [(ngModel)]="attribute.value" [style]="{height: '300px',overflow: 'auto'}" placeholder=""></quill-editor>
</div>
